import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../../utils';
import { FieldErrors } from './FieldErrors';
import { FieldInformation } from './FieldInformation';
import { FieldNotification } from './FieldNotificationWithLink';
import formStyles from '../styles.module.scss';
import styles from './styles.module.scss';

export type FieldWrapperProps = HTMLAttributes<HTMLDivElement> & {
  errors?: FieldNotification[];
  information?: FieldNotification[];
  hideErrorMessages?: boolean;
};

export const FieldWrapper = ({
  children,
  errors,
  information,
  hideErrorMessages = false,
}: FieldWrapperProps) => {
  const showError = !hideErrorMessages && errors && errors.length !== 0;
  const showInformation = !showError && information && information.length !== 0;

  return (
    <div className={joinClassNames(styles.fieldWrapper, showError && formStyles.hasError)}>
      {children}
      {showError && <FieldErrors errors={errors || []} />}
      {showInformation && <FieldInformation info={information || []} />}
    </div>
  );
};
